import { FC, useEffect, useMemo } from 'react';
import { get } from 'lodash';
// Import Hooks
import useBind from 'hooks/UseBind';
import { useStepValues, useStepperContext } from './context';
// Import Types
import { StepContainerProps } from './types';

const StepContainer: FC<StepContainerProps> = (props) => {
    const { mode, id, activeStepId, dependencies = {}, Component, submit, updateConfig, stepperSubmitCount } = props;
    const { allStepsValues } = useStepperContext();
    const { stepValues, setStepValues } = useStepValues(id);

    const depsObj = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const depsArr: any[] = [];

    Object.entries(dependencies).forEach(([stepId, stepDepsObj]) => {
        depsObj[stepId] = {};
        const tmpStepValues = allStepsValues[stepId];

        Object.entries(stepDepsObj).forEach(([stepField, fieldPath]) => {
            depsObj[stepId][stepField] = get(tmpStepValues, fieldPath);
            depsArr.push(depsObj[stepId][stepField]);
        });
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const deps = useMemo(() => depsObj, depsArr);

    const updateStepConfig = useBind(updateConfig, id);

    const isActiveStep = activeStepId === id;

    // submit step on leaving the step or when submitting the stepper
    useEffect(() => {
        if (!isActiveStep) {
            submit?.();
        }
    }, [isActiveStep, submit]);

    return (
        <Component
            mode={mode}
            stepValues={stepValues}
            setStepValues={setStepValues}
            deps={deps}
            updateStepConfig={updateStepConfig}
            stepperSubmitCount={stepperSubmitCount}
        />
    );
};

export default StepContainer;
